import { render, staticRenderFns } from "./Loan-originators.vue?vue&type=template&id=58752d40&scoped=true"
import script from "./Loan-originators.vue?vue&type=script&lang=js"
export * from "./Loan-originators.vue?vue&type=script&lang=js"
import style0 from "./Loan-originators.vue?vue&type=style&index=0&id=58752d40&prod&lang=scss"
import style1 from "./Loan-originators.vue?vue&type=style&index=1&id=58752d40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58752d40",
  null
  
)

export default component.exports